import { render } from "./SlideShow.vue?vue&type=template&id=a6332bd4"
import script from "./SlideShow.vue?vue&type=script&lang=js"
export * from "./SlideShow.vue?vue&type=script&lang=js"

import "./SlideShow.vue?vue&type=style&index=0&id=a6332bd4&lang=scss"

import exportComponent from "/codebuild/output/src1706908206/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__